module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_6005.f5d4660c.png";